import Lottie from 'lottie-react'
import { Modal } from '@mui/material'

import loaderAnimation from '@/assets/json/loaderAnimation.json'

function LoaderAnimation() {
  return (
    <Modal
      open={true}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(208, 212, 221, 0.5)'
      }}
    >
      <>
        <Lottie
          animationData={loaderAnimation}
          style={{
            width: '15vw',
            maxWidth: '200px'
          }}
        />
      </>
    </Modal>
  )
}

export default LoaderAnimation
